<template>
  <div class="content"></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {
    location.replace(
      "https://a.app.qq.com/o/simple.jsp?pkgname=com.founder.dps.founderreader"
    );
  },
  methods: {},
};
</script>

<style scoped lang="scss">
</style>